import { Controller } from "@hotwired/stimulus"

// Welle des Logins (Layout auth), portiert aus wlp.cloud/admins
// (login_screen_controller.js). Baut die Streifen; Farben und Bewegung stehen
// in ui/auth.css. Hell/Dunkel übernimmt der Controller theme.
export const SLAT_COUNT = 24

export default class extends Controller {
  static targets = ["art"]

  connect() {
    this.buildSlats()
  }

  disconnect() {
    if (this.hasArtTarget) this.artTarget.replaceChildren()
  }

  // Der Übergang zwischen dunklem Oberteil und farbigem Unterteil bildet einen
  // flachen Bogen (in der Mitte höher); die Verzögerung lässt die Welle laufen.
  buildSlats() {
    if (!this.hasArtTarget || this.artTarget.childElementCount > 0) return

    const width = 100 / SLAT_COUNT
    for (let i = 0; i < SLAT_COUNT; i++) {
      const x = (i + 0.5) / SLAT_COUNT
      const base = 34 + 30 * Math.pow(Math.abs(x - 0.5) * 2, 1.6)
      const slat = document.createElement("div")
      slat.className = "auth-slat"
      slat.style.left = `${i * width}%`
      slat.style.width = `${width + 0.15}%`
      slat.style.setProperty("--base", `${base.toFixed(1)}%`)
      slat.style.animationDelay = `${-i * 0.5}s`
      this.artTarget.appendChild(slat)
    }
  }
}
